import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ClockCounterClockwise, ChatCircleDots, Trash } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function History() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/conversations").then(r => setRows(r.data)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this conversation?")) return;
    await api.delete(`/conversations/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="px-4 md:px-8 py-8 max-w-3xl mx-auto w-full">
      <div className="flex items-center gap-3 mb-6">
        <ClockCounterClockwise size={22} weight="duotone" />
        <h1 className="font-heading text-4xl">History</h1>
      </div>

      {loading ? (
        <div className="text-ink-soft">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="text-ink-soft py-16 text-center border border-dashed border-line rounded-2xl">
          No conversations yet. <Link to="/" className="underline underline-offset-4">Start one</Link>.
        </div>
      ) : (
        <ul className="divide-y divide-line border border-line rounded-2xl bg-surface/40 overflow-hidden" data-testid="history-list">
          {rows.map((c) => (
            <li key={c.id} className="flex items-center gap-3 px-4 py-3 hover:bg-surface">
              <ChatCircleDots size={18} weight="duotone" className="text-ink-soft" />
              <Link to={`/c/${c.id}`} className="flex-1 min-w-0" data-testid={`history-item-${c.id}`}>
                <div className="text-sm truncate">{c.title}</div>
                <div className="text-xs text-ink-soft">{new Date(c.updated_at).toLocaleString()}</div>
              </Link>
              <button onClick={() => remove(c.id)} className="text-ink-soft hover:text-gk-red p-2" data-testid={`history-delete-${c.id}`}>
                <Trash size={16} weight="duotone" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
